import { StudentCountsInShapeColorByEnum } from "@/providers/store/api/shapes/enums/student-counts-in-shape.enum";

export const STUDENT_BY_TITLE_DICTIONARY: Record<StudentCountsInShapeColorByEnum, string> = {
  [StudentCountsInShapeColorByEnum.SCHOOL]: "Students by School",
  [StudentCountsInShapeColorByEnum.GRADE]: "Students by Grade",
  [StudentCountsInShapeColorByEnum.NONE]: "Students by None",
};
